import { computed, reactive, ref } from "vue";
import {
  addNotification,
  notifications,
  replaceNotification,
} from "./notifications";
import { locale } from "../locale";
import { fetcher } from "../api/fetcher";
import { ws_instance } from "../websocket/ws-instance";
import { authState } from "./auth";
import { getUserById } from "./usersState";

const notId = ref("");

const isShow = computed(() => {
  return !!notifications.find((n) => n.id === notId.value);
});

export const handsUpUsers = computed(() => {
  return handsUp.map((id) => getUserById(id)).filter((u) => !!u);
});

function showHandUpNotification() {
  if (handsUp.length === 0) return;
  const first = handsUpUsers.value[0];
  if (!first) {
    if (isShow.value) {
      removeHandUpNotification();
    }
    return;
  }
  const firstName =
    first.displayedName.length <= 35
      ? first.displayedName
      : first.displayedName.slice(0, 32) + "...";
  const morecount = handsUpUsers.value.length - 1;
  const newtext =
    morecount === 0
      ? `${firstName} ${locale.handUp.notification.one}`
      : `${firstName} ${locale.and} ${morecount} ${locale.handUp.notification.more}`;

  if (isShow.value) {
    replaceNotification(notId.value, newtext);
  } else {
    const id = addNotification(0, newtext, "HandUpIconN", true);
    notId.value = id;
  }
}

function removeHandUpNotification() {
  if (isShow.value && notId.value) {
    const not = notifications.find((n) => n.id === notId.value);
    not?.clear();
    notId.value = "";
  }
}

export const selfHandUpState = ref(false);

export async function selfHandUpToggle() {
  if (!selfHandUpState.value) {
    selfHandUpState.value = true;
    await fetcher.post({
      path: "/hand-up",
      payload: {},
    });
  } else {
    selfHandUpState.value = false;
    await fetcher.delete({
      path: "/hand-up",
    });
  }
}

const handsUp = reactive<string[]>([]);

export function isHandUp(userId: string) {
  return handsUp.includes(userId);
}

export function subscribeHandUp() {
  ws_instance.addEventListener("hand-up", (uid: string) => {
    addHandUp(uid);
    showHandUpNotification();
  });
  ws_instance.addEventListener("hand-down", (uid: string) => {
    if (uid === authState.id) {
      selfHandUpState.value = false;
    }
    removeHandUp(uid);
  });
}

function addHandUp(uid: string) {
  if (!handsUp.includes(uid)) {
    handsUp.push(uid);
  }
}

export function removeHandUp(uid: string) {
  if (handsUp.includes(uid)) {
    const idx = handsUp.findIndex((i) => i === uid);
    if (idx > -1) handsUp.splice(idx, 1);
  }
  if (handsUp.length === 0) removeHandUpNotification();
  else showHandUpNotification();
}

export function clearHandUpState() {
  handsUp.length = 0;
  selfHandUpState.value = false;
  removeHandUpNotification();
}

export function addInitialHands(hands: string[]) {
  handsUp.length = 0;
  handsUp.push(...hands);
  if (handsUp.length > 0) showHandUpNotification();
  else removeHandUpNotification();
}

export async function adminHandDown(userId: string) {
  await fetcher.delete({
    path: `/hand-up/another/${userId}`,
  });
}
